import mirrorCreator from "mirror-creator";

export default mirrorCreator(["OPEN_MODAL", "UPDATE_MODAL", "CLOSE_MODAL", "ADD_MODAL", "CLOSE_ALL_MODAL"]);
